<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-lock'"
            :category="$t(`nav.changePassword`)"
            :subCategory="''"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="changePassword">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.username')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text border-right-0">
                                            <i class="fas fa-user"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control pl-3" :placeholder="$t('label.username')" v-model="username" disabled>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.current_password')}}</label>
                                <div class="input-group bg-white shadow-inset-2 position-relative">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                    </div>
                                    <input :type="currentType" class="form-control bg-transparent pl-3" :placeholder="$t('label.current_password')" autocomplete="off" v-model="currentPassword">
                                    <a class="show-password-icon link" @click="currentType = currentType == 'password' ? 'text' : 'password'">
                                        <i class="fas" :class="currentType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.password')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                    </div>
                                    <input :type="newType" class="form-control bg-transparent pl-3" :placeholder="$t('label.password')" v-model="newPassword">
                                    <a class="show-password-icon link" @click="newType = newType == 'password' ? 'text' : 'password'">
                                        <i class="fas" :class="newType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="form-group mb-1">
                                <label class="form-label">{{$t('label.confirmed_password')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                    </div>
                                    <input :type="confirmType" class="form-control bg-transparent pl-3" :placeholder="$t('label.confirmed_password')" v-model="confirmPassword" @keyup="validateNewAndConfirmPassword">
                                    <a class="show-password-icon link" @click="confirmType = confirmType == 'password' ? 'text' : 'password'">
                                        <i class="fas" :class="confirmType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </a>
                                </div>
                            </div>
                            <div id="err" class="error-validation"></div>
                            <div class="text-left mt-5">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../Bread_Crumb'
export default {
    name: "changePassword",
    components:{
        BreadCrumb
    },
    data(){
        return{
            category: "Change Password",
            username: "", 
            currentPassword: "", newPassword: "", confirmPassword: "",
            currentType: "password", newType: "password", confirmType: "password", 
        }
    },
    methods:{
        validateNewAndConfirmPassword(){
            document.getElementById('err').innerHTML = this.newPassword != this.confirmPassword ? this.$i18n.t('message.error.diff_password') : null
        },
        changePassword(){
            let $vm = this;
            var data = {
                username: this.username,
                password: this.currentPassword,
                newpassword: this.confirmPassword,
            }
            $vm.$axios({
                method: 'post', 
                url: $vm.$api.CHANGE_PASSWORD,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.password'));
                }
            })
            .catch((err) => {
                $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
            })
        },
        closeModal(isError){
            if(!isError){
                this.$router.push({ name: 'login' })
                this.$parent.logout();
            }
            this.$parent.isModalShow = false;
        }
    },
    mounted(){
        let $vm = this;
        $vm.username = $vm.$store.state.userName;
        $vm.currentPassword = ""
    }
}
</script>
<style scoped>
.show-password-icon{
    position: absolute;
    right: 10px;
    top: 10px
}
.link{
    cursor: pointer;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>